import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  description: {
    color: theme.palette.common.white,
    fontSize: 15,
  },
  title: {
    fontSize: 18,
    color: theme.palette.common.white,
  },
  mainInformationHeader: {
    '&::before': {
      display: 'block',
      position: 'relative',
      top: -9,
      content: '""',
      width: 3,
      height: 0,
      transform: 'translateX(-50%)',
      borderLeft: '15px solid transparent',
      borderRight: '15px solid transparent',
      borderTop: '15px solid #EEEEEE',
    },
  },
  divider: {
    height: 1,
    width: 242,
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(1, 0),
  },
}));
